"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ImportImageCopyrightConfirm;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIConfirmModal = _interopRequireDefault(require("UIComponents/dialog/UIConfirmModal"));

var getI18nKey = function getI18nKey(suffix) {
  return "FileManagerLib.panels.fromUrl.copyrightNotice." + suffix;
};

function ImportImageCopyrightConfirm(_ref) {
  var onConfirm = _ref.onConfirm,
      onReject = _ref.onReject;
  return _react.default.createElement(_UIConfirmModal.default, {
    message: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('heading')
    }),
    description: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('description')
    }),
    confirmLabel: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('confirm')
    }),
    rejectLabel: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('reject')
    }),
    onConfirm: onConfirm,
    onReject: onReject
  });
}

ImportImageCopyrightConfirm.propTypes = {
  onConfirm: _propTypes.default.func.isRequired,
  onReject: _propTypes.default.func.isRequired
};
module.exports = exports.default;